import React from "react";

import ProjectDevelopmentMetrics from "./ProjectDevelopmentMetrics";
import ProjectTimeStats from "./ProjectTimeStats";

type ChartType = "timeStats" | "developmentMetrics";

interface Props {
  projectId: number;
  fromDate: Date;
  toDate: Date;
  selectedChart: ChartType;
}

const charts = {
  timeStats: ProjectTimeStats,
  developmentMetrics: ProjectDevelopmentMetrics,
};

export const ProjectCharts = ({
  projectId,
  fromDate,
  toDate,
  selectedChart,
}: Props) => {
  const ChartComponent = charts[selectedChart];

  return (
    <ChartComponent
      project_id={projectId}
      fromDate={fromDate}
      toDate={toDate}
    />
  );
};

export default ProjectCharts;
